import { CustomProjectEntity } from '@entities/CustomProject/Types';

export const GetTemplateAndFragmentQuestion = (
    project: CustomProjectEntity,
    questionId: string
) => {
    const template = project.templates?.[0];
    if (!template) {
        return;
    }

    const templateQuestion = template.questions.find(
        question => question.uuid === questionId
    );
    if (templateQuestion) {
        return templateQuestion;
    }

    const fragmentQuestion = template.fragments.flatMap(
        fragment => fragment.questions
    );
    return fragmentQuestion.find(question => question.uuid === questionId);
};
